module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/play-store.37402368.png";